const REDUX_USER_STORAGE_KEY = 'redux_localstorage_simple_user'
const REOWN_CONNECTION_TYPE = 'REOWN'
const LEGACY_WALLET_STORAGE_PATTERNS = [
  /^walletconnect/i,
  /^wc@/i,
  /^WALLETCONNECT/i,
  /^WEB3_CONNECT_CACHED_PROVIDER$/,
  /^-walletlink/i,
  /^walletlink/i,
  /^coinbase/i,
]

function removeLegacyWalletStorage() {
  for (let index = window.localStorage.length - 1; index >= 0; index--) {
    const key = window.localStorage.key(index)
    if (key && LEGACY_WALLET_STORAGE_PATTERNS.some((pattern) => pattern.test(key))) {
      window.localStorage.removeItem(key)
    }
  }
}

function sanitizePersistedUserState() {
  const storedUser = window.localStorage.getItem(REDUX_USER_STORAGE_KEY)
  if (!storedUser) return

  try {
    const user = JSON.parse(storedUser)
    if (user?.selectedWallet && user.selectedWallet !== REOWN_CONNECTION_TYPE) {
      delete user.selectedWallet
      window.localStorage.setItem(REDUX_USER_STORAGE_KEY, JSON.stringify(user))
    }
  } catch {
    window.localStorage.removeItem(REDUX_USER_STORAGE_KEY)
  }
}

try {
  sanitizePersistedUserState()
  removeLegacyWalletStorage()
} catch (error) {
  console.debug(`Failed to sanitize wallet storage: ${error}`)
}
